import { createSelector } from "reselect";
import { managementPortal } from "../../state/config/config.selector";
import { selectDashboardSelectedProject } from "../../state/workspaces/projects.selector";

export const managementPortalUserProfileUrl = createSelector(
  [managementPortal],
  (managementPortalUrl): string => {
    return `${managementPortalUrl}/u`;
  },
);

export const managementPortalBillingUrl = createSelector(
  [managementPortalUserProfileUrl],
  (profileLink): string => {
    return `${profileLink}/billing`;
  },
);

export const managementPortalProjectUrl = createSelector(
  [managementPortalUserProfileUrl, selectDashboardSelectedProject],
  (managementPortalUrl, project): string | undefined => {
    if (!project?.id) return undefined;
    return `${managementPortalUrl}/projects/${project.id}`;
  },
);
